import React, { Component } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import NoData from "../Dashboard/Charts/NoData/NoData";
import moment from "moment";
import { numberWithCommas } from "../Dashboard/utils";

class TotalViewsByDevice extends Component {
    constructor(props) {
        super(props);
        this.chartComponent = React.createRef();
        this.state = {
            rerender: 0,
        };
    }

    componentDidMount() {
        // if (!this.props.isFBPage) {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent?.current?.chart?.setSize(null, null);
                this.chartComponent?.current?.chart?.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef?.current) {
            this.ro.observe(this.props.widgetContainerRef?.current);
        } else {
            this.setState({ rerender: this.state.rerender + 1 });
        }
        // }
    }

    componentWillUnmount() {
        if (!this.props.isFBPage) {
            this.ro.disconnect();
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.rerender) {
            if (this.props.widgetContainerRef?.current) {
                this.ro.observe(this.props.widgetContainerRef?.current);
                this.setState({ rerender: 0 });
            } else if (prevState.rerender !== this.state.rerender) {
                setTimeout(() => {
                    this.setState({ rerender: this.state.rerender + 1 });
                }, 100);
            }
        }
    }

    // componentDidUpdate(prevProps) {
    //     if (this.props.resizedCount !== prevProps.resizedCount && this.props.data && !this.props.data.nodata) {
    //         this.chartComponent.current?.chart?.setSize(null, null);
    //         this.chartComponent.current?.chart?.reflow();
    //     }
    // }

    getOptions = () => {
        if (this.props.graph_type == "line") return this.getLineOptions();
        else return this.getBarOptions();
    };

    getLineOptions = () => {
        let x = this.props.data;
        const height = this.props.isFBPage ? "338px" : null;
        const legendAlign = this.props.isFBPage ? "right" : "center";

        let formattedDataComputer = x.computers ? x.computers.data : [];
        formattedDataComputer.forEach((item) => {
            item[0] = moment(item[0]).set({ h: 0, m: 0, s: 0, ms: 0 }).valueOf();
        });
        let formattedDataMobile = x.mobiles ? x.mobiles.data : [];
        formattedDataMobile.forEach((item) => {
            item[0] = moment(item[0]).set({ h: 0, m: 0, s: 0, ms: 0 }).valueOf();
        });

        const pageViewConfig = {
            plotOptions: {
                series: {
                    cursor: "pointer",
                    stacking: null,
                },
            },
            chart: {
                type: "spline",
                className: "skiptranslate",
                // height: 300,
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
                height,
            },
            credits: {
                enabled: false,
            },
            lang: {
                noData: "No Data.",
            },
            legend: {
                enabled: this.props.showLegend,
                // itemStyle: {
                //     fontFamily: "'Roboto', sans-serif",
                //     textTransform: "capitalize ",
                //     color: "#1f2e3d",
                // },
                alignColumns: false,
                align: legendAlign,
            },
            noData: {
                // style: {
                //     fontWeight: "bold",
                //     fontSize: "14px",
                //     color: "#1f2e3d",
                //     fontFamily: "'Roboto', sans-serif",
                // },
                // position: {
                //     align: "center",
                // },
            },
            title: {
                text: "",
            },
            yAxis: {
                title: "",
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "ShortDash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                min: 0,
                allowDecimals: false,
            },
            xAxis: {
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: "%l:%M:%S.%L %p",
                    second: "%l:%M:%S %p",
                    minute: "%l:%M %p",
                    hour: "%l:%M %p",
                    day: "%e %b",
                    week: "%e. %b",
                    month: "%b '%y",
                    year: "%Y",
                },
            },
            tooltip: {
                crosshairs: true,
                backgroundColor: "#fff",
                borderRadius: 6,
                formatter: function () {
                    return `<span>${moment(this.x).format("LLLL")}</span>
                    <br/><span>${this.series.name}: <b>${numberWithCommas(this.y)}</b></span>`;
                },
            },
            series: [
                { color: "#905AC7", name: "Computers", data: formattedDataComputer },
                { color: "#54BFA8", name: "Mobiles", data: formattedDataMobile },
            ],
            time: {
                useUTC: false,
            },
        };

        return pageViewConfig;
    };
    getBarOptions = () => {
        let x = this.props.data;
        const height = this.props.isFBPage ? "338px" : null;
        const legendAlign = this.props.isFBPage ? "right" : "center";

        let formattedDataComputer = x.computers ? x.computers.data : [];
        formattedDataComputer.forEach((item) => {
            item[0] = moment(item[0]).set({ h: 0, m: 0, s: 0, ms: 0 }).valueOf();
        });
        let formattedDataMobile = x.mobiles ? x.mobiles.data : [];
        formattedDataMobile.forEach((item) => {
            item[0] = moment(item[0]).set({ h: 0, m: 0, s: 0, ms: 0 }).valueOf();
        });

        const pageViewColumnConfig = {
            //renderTo: 'charts-column',
            plotOptions: {
                series: {
                    cursor: "pointer",
                    stacking: "normal",
                    // pointRange: tick_interval,
                },
            },
            chart: {
                // height: 300,
                type: "column",
                height,
            },
            credits: {
                enabled: false,
            },
            title: {
                text: "",
            },
            yAxis: {
                title: "",
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "ShortDash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                min: 0,
                allowDecimals: false,
            },
            xAxis: {
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: "%l:%M:%S.%L %p",
                    second: "%l:%M:%S %p",
                    minute: "%l:%M %p",
                    hour: "%l:%M %p",
                    day: "%e %b",
                    week: "%e. %b",
                    month: "%b '%y",
                    year: "%Y",
                },
            },
            lang: {
                noData: "No Data.",
            },
            legend: {
                enabled: this.props.showLegend,
                itemStyle: {
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "capitalize ",
                    color: "#1f2e3d",
                },
                alignColumns: false,
                align: legendAlign,
            },
            tooltip: {
                crosshairs: true,
                backgroundColor: "#fff",
                borderRadius: 6,
                formatter: function () {
                    return `<span>${moment(this.x).format("LLLL")}</span>
                    <br/><span>${this.series.name}: <b>${numberWithCommas(this.y)}</b></span>`;
                },
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "14px",
                    color: "#1f2e3d",
                    fontFamily: "'Roboto', sans-serif",
                },
                position: {
                    align: "center",
                },
            },
            series: [
                { color: "#905AC7", name: "Computers", data: formattedDataComputer },
                { color: "#54BFA8", name: "Mobiles", data: formattedDataMobile },
            ],
            time: {
                useUTC: false,
            },
        };

        return pageViewColumnConfig;
    };

    isNoData = () => {
        return this.props.data
            ? (this.props.data.computers ? (this.props.data.computers.data && this.props.data.computers.data.length > 0 ? false : true) : true) &&
                  (this.props.data.mobiles ? (this.props.data.mobiles.data && this.props.data.mobiles.data.length > 0 ? false : true) : true)
            : true;
    };

    render() {
        return (
            <>
                {!this.isNoData() ? (
                    <>
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={this.getOptions()}
                            ref={this.chartComponent}
                            containerProps={!this.props.isFBPage && { style: { width: "100%", height: "calc(100% - 70px)" } }}
                        />
                    </>
                ) : (
                    <NoData message={this.props.pageStatus ? "Page is Inactive. Please re-authenticate" : ""} />
                )}
            </>
        );
    }
}

export default TotalViewsByDevice;
